import { Check } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { SUBSCRIPTIONS, SUBSCRIPTION_NOTE } from "@/data/content";

const Subscriptions = () => (
  <section id="abonnemang" className="bg-navy py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>Månadsabonnemang</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Vad ingår i månadsabonnemanget?
        </h2>
        <p className="mt-4 text-base text-cream/60 sm:text-lg">
          Löpande tjänster som håller din digitala närvaro uppdaterad, säker och aktiv.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {SUBSCRIPTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08} className="h-full">
            <article
              data-testid={s.testId}
              className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy2 p-6 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-teal/60 hover:shadow-2xl hover:shadow-black/30 sm:p-7"
            >
              <h3 className="font-display text-xl font-bold text-white">{s.title}</h3>
              <p className="mt-1.5 font-display text-2xl font-extrabold tracking-tight text-orange">{s.price}</p>
              <ul className="mt-6 flex-1 space-y-2.5">
                {s.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-cream/80">
                    <Check size={16} className="mt-0.5 shrink-0 text-orange2" aria-hidden="true" />
                    {f}
                  </li>
                ))}
              </ul>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mx-auto mt-10 max-w-3xl text-center text-sm leading-relaxed text-cream/50">{SUBSCRIPTION_NOTE}</p>
      </Reveal>
    </div>
  </section>
);

export default Subscriptions;
